module.exports = __webpack_public_path__ + "static/media/tsukasa-aoi-lose.6c617bdc.jpg";